import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { Avatar, Box, Dialog, Grid, IconButton, Typography } from '@mui/material';
import { CloseCircle, Edit2, User } from 'iconsax-react';
import { PrimaryButon } from '../../../../../components/common/button/PrimaryButon';
import { WidgetHeader } from '../../../../../components/common/header/widgetHeader/WidgetHeader';
import { QInput } from '../../../../../components/common/inputs/QInput';
import { palette } from '../../../../../../theme/palette';
import { translate } from '@application/common/helpers/translate';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { Controller, useForm } from 'react-hook-form';
import { addContactPersonAsync, getContactPersonByIdAsync, updateContactPersonAsync } from '@application/features/contactPersons/contactPersonThunk';
import { useSearchParams } from 'react-router-dom';
import { centered } from '@ui/containers/freelancer/account/style';
const theme = palette('light');
export const ContactPersonDialog = ({ open, handleClose, type, contactId }) => {
    const [avatarImage, setAvatarImage] = useState(undefined);
    const [avatarPreview, setAvatarPreview] = useState(null);
    const { client } = useAppSelector((state) => state.client);
    const { contactPerson } = useAppSelector((state) => state.contactPerson);
    const [error, setError] = useState(null);
    const dispatch = useAppDispatch();
    const fileInputRef = useRef(null);
    const [searchParams] = useSearchParams();
    const userId = searchParams.get('id');
    const { control, handleSubmit, setValue, reset, formState: { errors } } = useForm({});
    useEffect(() => {
        if (contactId && open && type == 'edit') {
            dispatch(getContactPersonByIdAsync(contactId))
                .unwrap()
                .then((response) => {
                setAvatarPreview(response.profilePicture);
                const fieldsToUpdate = {
                    firstName: response?.firstName || '',
                    lastName: response?.lastName || '',
                    jobTitle: response?.jobTitle || '',
                    email: response?.email || '',
                    phoneNo: response?.phoneNo || '',
                    linkedInUrl: response?.linkedInUrl || ''
                };
                Object.entries(fieldsToUpdate).forEach(([key, value]) => {
                    setValue(key, value);
                });
            });
        }
    }, [dispatch, contactId, open, type]);
    const handleImageChange = (event) => {
        const file = event.target.files && event.target.files[0];
        if (file) {
            const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
            const maxSizeInMB = 1;
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
            if (!validTypes.includes(file.type)) {
                setError('Only PNG, JPEG, and JPG files are allowed.');
                setAvatarImage(undefined);
                return;
            }
            if (file.size > maxSizeInBytes) {
                setError(translate('validations.maxAllowedFileSize'));
                setAvatarImage(undefined);
                return;
            }
            setError(null);
            setAvatarImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setAvatarPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const file = event.dataTransfer.files[0];
        if (file) {
            const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
            const maxSizeInMB = 1;
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
            if (!validTypes.includes(file.type)) {
                setError('Only PNG, JPEG, and JPG files are allowed.');
                setAvatarImage(undefined);
                return;
            }
            if (file.size > maxSizeInBytes) {
                setAvatarImage(undefined);
                setError(translate('validations.maxAllowedFileSize'));
                return;
            }
            setError(null);
            setAvatarImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setAvatarPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    const handleEditClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
    const HandleClose = () => {
        setAvatarImage(undefined);
        setAvatarPreview(null);
        contactId = undefined;
        setError(null);
        reset({
            firstName: '',
            lastName: '',
            jobTitle: '',
            email: '',
            phoneNo: '',
            linkedInUrl: ''
        });
        handleClose();
    };
    const onSubmit = (contact) => {
        contact.clientId = userId ? userId : '';
        contact.profilePicture = avatarImage;
        if (contactId) {
            if (contactPerson)
                contact.id = contactPerson?.id;
            if (contactPerson?.profilePicture && (contact.profilePicture === undefined || contact.profilePicture === null)) {
                return dispatch(updateContactPersonAsync(contact))
                    .unwrap()
                    .then((response) => {
                    if (response)
                        HandleClose();
                });
            }
            else {
                return dispatch(updateContactPersonAsync(contact))
                    .unwrap()
                    .then((response) => {
                    if (response)
                        HandleClose();
                });
            }
        }
        else {
            dispatch(addContactPersonAsync(contact));
        }
        HandleClose();
    };
    return (_jsx(Dialog, { open: open, onClose: HandleClose, maxWidth: false, BackdropProps: {
            sx: {
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(74, 74, 74, 0.25)'
            }
        }, children: _jsxs(Box, { width: { xs: 600, sm: 700, md: 904 }, children: [_jsxs(WidgetHeader, { background: 'white', children: [_jsx(Typography, { variant: 'h5', color: 'black', children: type === 'edit' ? 'Edit' : 'Add new contact person' }), _jsx(IconButton, { onClick: HandleClose, children: _jsx(CloseCircle, { style: { color: 'black' } }) })] }), _jsx(Box, { sx: { padding: '25px' }, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsxs(Grid, { item: true, md: 3, xs: 12, children: [_jsx(Box, { mt: 2, display: 'flex', justifyContent: 'center', children: _jsxs(Box, { onDrop: handleDrop, onDragOver: handleDragOver, children: [!avatarPreview && (_jsx("label", { htmlFor: 'avatarInput', children: _jsxs(Box, { sx: {
                                                            width: '155px',
                                                            height: '155px',
                                                            borderRadius: '50%',
                                                            border: '1px dashed #FFBC00',
                                                            background: '#FFF7E0',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            position: 'relative',
                                                            zIndex: 10
                                                        }, children: [_jsx(Box, { sx: {
                                                                    zIndex: 1,
                                                                    position: 'absolute',
                                                                    top: '50%',
                                                                    left: '50%',
                                                                    transform: 'translate(-50%, -50%)'
                                                                }, children: _jsx(User, { style: {
                                                                        width: '80px',
                                                                        height: '80px',
                                                                        color: theme.primary.light
                                                                    } }) }), _jsx(Box, { sx: {
                                                                    zIndex: 9,
                                                                    textAlign: 'center'
                                                                }, children: _jsxs(Typography, { variant: 'subtitle2', color: theme.primary.main, children: ["Upload your profile picture", ' ', _jsx("span", { style: { textDecoration: 'underline', cursor: 'pointer' }, children: "browse" })] }) })] }) })), _jsx(Controller, { control: control, name: 'profilePicture', render: ({ field }) => (_jsx("input", { id: 'avatarInput', type: 'file', accept: 'image/*', onChange: (e) => {
                                                            handleImageChange(e);
                                                            field.onChange(e);
                                                        }, ref: fileInputRef, style: { display: 'none' } })) }), avatarPreview && (_jsxs(Box, { position: 'relative', children: [_jsx(Avatar, { src: avatarPreview, sx: { width: '150px', height: '150px', marginBottom: '20px' } }), _jsx(Box, { sx: {
                                                                position: 'absolute',
                                                                bottom: 10,
                                                                right: 6,
                                                                width: 35,
                                                                height: 35,
                                                                background: 'white',
                                                                borderRadius: '50%',
                                                                ...centered,
                                                                cursor: 'pointer'
                                                            }, onClick: handleEditClick, children: _jsx(Edit2, { size: '18px', color: '#FFBC00' }) })] }))] }) }), _jsx(Box, { textAlign: 'center', width: '100%', children: error && (_jsx(Typography, { color: 'error', textAlign: 'center', variant: 'caption', children: error })) })] }), _jsx(Grid, { item: true, md: 4, xs: 6, children: _jsxs(Box, { gap: 2.7, display: 'flex', flexDirection: 'column', children: [_jsx(Controller, { name: 'firstName', defaultValue: '', control: control, rules: {
                                                required: { value: true, message: translate('validations.fieldIsRequired') },
                                                maxLength: {
                                                    value: 20,
                                                    message: translate('validations.maximumCharactersAllowed', { count: 20 })
                                                }
                                            }, render: ({ field }) => (_jsx(QInput, { ...field, placeholder: 'First name', label: 'First name', errormsg: errors.firstName ? errors.firstName.message : '' })) }), _jsx(Controller, { name: 'lastName', defaultValue: '', control: control, rules: {
                                                required: { value: true, message: translate('validations.fieldIsRequired') },
                                                maxLength: {
                                                    value: 20,
                                                    message: translate('validations.maximumCharactersAllowed', { count: 20 })
                                                }
                                            }, render: ({ field }) => (_jsx(QInput, { ...field, placeholder: 'Last name', label: 'Last name', errormsg: errors.lastName ? errors.lastName.message : '' })) }), _jsx(Controller, { name: 'jobTitle', defaultValue: '', control: control, rules: {
                                                required: { value: true, message: translate('validations.fieldIsRequired') },
                                                maxLength: {
                                                    value: 20,
                                                    message: translate('validations.maximumCharactersAllowed', { count: 20 })
                                                }
                                            }, render: ({ field }) => (_jsx(QInput, { ...field, placeholder: 'Job Title', label: 'Job Title', errormsg: errors.jobTitle ? errors.jobTitle.message : '' })) })] }) }), _jsx(Grid, { item: true, md: 4, xs: 6, children: _jsxs(Box, { gap: 2.7, display: 'flex', flexDirection: 'column', children: [_jsx(Controller, { name: 'email', defaultValue: '', control: control, rules: {
                                                required: { value: true, message: translate('validations.fieldIsRequired') },
                                                maxLength: {
                                                    value: 100,
                                                    message: translate('validations.maximumCharactersAllowed', { count: 100 })
                                                },
                                                pattern: {
                                                    value: /^(?!.*\.\.)[A-Z0-9]+[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                    message: 'Email address is not valid.'
                                                }
                                            }, render: ({ field }) => (_jsx(QInput, { ...field, placeholder: 'Business Email', label: 'Business Email', errormsg: errors.email ? errors.email.message : '' })) }), _jsx(Controller, { name: 'phoneNo', defaultValue: '', control: control, rules: {
                                                required: { value: true, message: translate('validations.fieldIsRequired') },
                                                maxLength: {
                                                    value: 20,
                                                    message: translate('validations.maximumCharactersAllowed', { count: 20 })
                                                }
                                            }, render: ({ field }) => (_jsx(QInput, { ...field, placeholder: 'Business Phone', label: 'Business Phone', errormsg: errors.phoneNo ? errors.phoneNo.message : '' })) }), _jsx(Controller, { name: 'linkedInUrl', defaultValue: '', control: control, rules: {
                                                maxLength: {
                                                    value: 100,
                                                    message: translate('validations.maximumCharactersAllowed', { count: 100 })
                                                }
                                            }, render: ({ field }) => (_jsx(QInput, { ...field, placeholder: 'LinkedIn URL', label: 'LinkedIn URL', errormsg: errors.linkedInUrl ? errors.linkedInUrl.message : '' })) }), _jsx(PrimaryButon, { type: 'submit', onClick: handleSubmit(onSubmit), mt: 15, children: "Save contact person" })] }) })] }) })] }) }));
};
